export function showToast(message, type = 'success') {
    const region = document.querySelector('.v2-toast-region');

    if (!region || !message) {
        return;
    }

    const isSuccess = type === 'success';
    const toast = document.createElement('div');

    toast.className = `v2-toast is-${isSuccess ? 'success' : 'error'}`;
    toast.setAttribute('role', isSuccess ? 'status' : 'alert');

    toast.innerHTML = `
        <i
            class="bi ${
                isSuccess
                    ? 'bi-check-circle-fill'
                    : 'bi-exclamation-circle-fill'
            }"
            aria-hidden="true"
        ></i>
        <span></span>
    `;

    toast.querySelector('span').textContent = message;
    region.appendChild(toast);

    requestAnimationFrame(() => {
        toast.classList.add('is-visible');
    });

    window.setTimeout(() => {
        toast.classList.remove('is-visible');

        window.setTimeout(() => {
            toast.remove();
        }, 250);
    }, 4000);
}